export const shouldShowAvatar = (messages, index, timeThreshold = 30 * 60 * 1000) => {
    if (!messages || !Array.isArray(messages)) return false;

    const currentMessage = messages[index];

    const nextMessage = messages[index + 1];
    if (!nextMessage) return true;

    const sameUser = currentMessage?.user?.id === nextMessage?.user?.id;
    const currentTime = new Date(currentMessage?.created_at || 0).getTime();
    const nextTime = new Date(nextMessage?.created_at || 0).getTime();

    // Show avatar if next message is from a different user or time gap is large
    if (!sameUser) return true;
    if ((nextTime - currentTime) > timeThreshold) return true;

    // Otherwise, do not show avatar
    return false;
};